import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = window.__lenis;

    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        if (lenis) lenis.scrollTo(el);
        else el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
